import React from "react";
import "./DataTagSensitivityFilter.scss";

const OPTIONS = [
  { key: "CRITICAL", label: "Critical", color: "#e22d1b" },
  { key: "HIGH", label: "High", color: "#f44336" },
  { key: "MEDIUM", label: "Medium", color: "#FC6213" },
  { key: "LOW", label: "Low", color: "#081981" },
  { key: "NO_RISK", label: "None", color: "#650176" },
  { key: "NO_SENSITIVITY", label: "Pending Classification", color: "#9e9e9e" },
];

export default function DataTagSensitivityFilter({
  value = [],
  onChange,
  loc,
}) {
  const toggleSelection = (key) => {
    const updated = value.includes(key)
      ? value.filter((x) => x !== key)
      : [...value, key];

    onChange?.(updated);
  };

  const visibleOptions =
    loc === "UsersTable" || loc === "data-estate-drives"
      ? OPTIONS.filter(
          (opt) =>
            opt.key !== "NO_RISK" &&
            opt.key !== "NO_SENSITIVITY"
        )
      : OPTIONS;

  return (
    <div className="sensitivity-filter-container">
      {visibleOptions.map((opt) => {
        const isActive = value.includes(opt.key);

        return (
          <div
            key={opt.key}
            className={`sensitivity-dot ${isActive ? "active" : ""}`}
            style={{
              borderColor: opt.color,
              backgroundColor: isActive ? opt.color : "transparent",
            }}
            title={opt.label}
            onClick={() => toggleSelection(opt.key)}
          />
        );
      })}
    </div>
  );
}